import * as zod from 'zod';

// Mesmo intervalo aceito pelo backend (RecuperacaoSenhaService), pra não
// deixar o usuário digitar uma senha que a API vai recusar depois.
const MIN_SENHA = 8;
// IGUsuario.Senha tem 20 posições; a ItWorks.Api recusa acima disso.
const MAX_SENHA = 20;

export const redefinirSenhaValidationSchema = zod
  .object({
    senha: zod
      .string({ required_error: 'Campo obrigatório' })
      .min(MIN_SENHA, `A senha deve ter pelo menos ${MIN_SENHA} caracteres`)
      .max(MAX_SENHA, `A senha deve ter no máximo ${MAX_SENHA} caracteres`),
    confirmarSenha: zod.string({ required_error: 'Campo obrigatório' }),
  })
  .refine(dados => dados.senha === dados.confirmarSenha, {
    message: 'As senhas não coincidem',
    path: ['confirmarSenha'],
  });

export type RedefinirSenhaFormData = zod.infer<typeof redefinirSenhaValidationSchema>;
